import { queryOptions } from "@tanstack/react-query"
import { request } from "@utils/request"

type SolutionDetails = {
  id: string
  solutionUid: string
  customerKey: string
  name: string
  description: string | null
  platform: string
  country: string
  platformArea: string
  customer: {
    customerKey: string
    name: string
    description: string | null
    category: string | null
    contract: string
    country: string
    currency: string
    billingAddress: string
    vatNumber: string
    partnerId: string
    platformArea: string
    isDeleted: boolean | null
    isProspect: boolean
    createdTimestamp: Date
  }
}

export const solutionDetailsQuery = (solutionUid: string) =>
  queryOptions({
    queryKey: ["solutionDetails", solutionUid] as const,
    queryFn: () =>
      request.get<SolutionDetails>(
        `/api/systemadmin/v1/solutions/${solutionUid}/details`,
      ),
  })
